import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { post } from '../../Auths/AuthToken';
import Period from '../Appointment/period';
import PeriodSelection from '../Appointment/PeriodSelection';
import { format } from 'date-fns';
import { DEFAULT_LOCAL_PATH } from '../../../constents';
import { setTodoPeriod } from '../../../redux/slices/scheduler/todoSlice';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { updateSearchParams } from '../../../redux/slices/scheduler/appointmentSlice';
import { updateNoteSerch } from '../../../redux/slices/Notes/counsellingNoteSlice';
import { updateTplanSerch } from '../../../redux/slices/Notes/treatmentPlanSlice';
import setUiMessage from '../../../Utilities/Tostify';

function AppToDo() {
  const dispatch = useDispatch();

  const { user } = useSelector((store) => store.auth);
  const { todoPeriodFilter } = useSelector((store) => store.todo);
  const { appSearchPrams } = useSelector((store) => store.appointment);

  const [allResource, setAllResource] = useState(null);
  const [todoCount, setTodoCount] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/appointment/Todo/getToDoCountData', {
          provId:
            parseInt(user?.userType) !== 1 &&
            user?.id === appSearchPrams?.allProviders
              ? 0
              : appSearchPrams?.allProviders,
          startDate: format(
            new Date(todoPeriodFilter?.startDate),
            'yyyy-MM-dd'
          ),
          endDate: format(new Date(todoPeriodFilter?.endDate), 'yyyy-MM-dd'),
          staffUserId: user?.id,
        });

        if (response.status === 200) {
          setAllResource(response?.data?.allResource);
          setTodoCount(response?.data?.todoCount);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [appSearchPrams, user, todoPeriodFilter]);
  const handleResource = (e) => {
    dispatch(
      updateSearchParams({
        key: 'allProviders',
        value: e.target.value,
      })
    );
  };

  const handleRedirectNote = (type) => {
    if (type === 'pending_rec') {
      dispatch(updateNoteSerch({ key: 'noteStSerch', value: 1 }));
      navigate(`${DEFAULT_LOCAL_PATH}/notes/counNote/pendingrec`);
    } else if (type === 'pending_sig') {
      dispatch(updateNoteSerch({ key: 'noteStSerch', value: 2 }));
      navigate(`${DEFAULT_LOCAL_PATH}/notes/counNote/pendingsig`);
    } else if (type === 'pending_review_sig') {
      dispatch(updateNoteSerch({ key: 'noteStSerch', value: '0' }));
      navigate(`${DEFAULT_LOCAL_PATH}/notes/counNote/pendingreviewcosign`);
    } else if (type === 'treat_update') {
      dispatch(
        updateTplanSerch({
          key: 'actionSt',
          value: 3,
        })
      );
      navigate(`${DEFAULT_LOCAL_PATH}/notes/treatPlan/update`);
    } else if (type === 'treat_review') {
      dispatch(
        updateTplanSerch({
          key: 'actionSt',
          value: 4,
        })
      );
      navigate(`${DEFAULT_LOCAL_PATH}/notes/treatPlan/review`);
    }
  };

  return (
    <div>
      <div id="schSumrySection" className="sch-Sumry-Section">
        <div className="child-body-rw appt-sec-fst-rw">
          <Period
            periodFilter={todoPeriodFilter}
            setPeriodFilter={(obj) => dispatch(setTodoPeriod(obj))}
          />
          <PeriodSelection
            selectedPeriod={todoPeriodFilter}
            setPeriodFilter={(obj) => dispatch(setTodoPeriod(obj))}
          />
          <div className="appt-search">
            <span className="appt-loc-val">
              <select
                className="appt-col-slct"
                value={appSearchPrams.allProviders}
                onChange={handleResource}
              >
                <option value="">All</option>
                {allResource &&
                  allResource.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.resName}
                      </option>
                    );
                  })}
              </select>
            </span>
          </div>
          <div className="appt-sumary">
            <span className="appt-loc-val">
              <span className="prnt-btn hide">Print To-Do</span>
            </span>
          </div>
        </div>

        <div className="appt-body-main">
          <div className="appt-smry-blk">
            <div className="appt-smry-hdng bold">To-Do List</div>
            <div className="appt-smry-inr-bdy to-do-sectn">
              <ol>
                <li
                  className="appt-smry-inr-lbl"
                  onClick={() => handleRedirectNote('pending_rec')}
                >
                  You have <Link>{todoCount?.recordingCount} notes</Link>{' '}
                  pending for recording
                </li>
                <li
                  className="appt-smry-inr-lbl alt-rw"
                  onClick={() => handleRedirectNote('pending_sig')}
                >
                  You have <Link>{todoCount?.signCount} notes</Link> pending for
                  signature
                </li>
                <li
                  className="appt-smry-inr-lbl"
                  onClick={() => handleRedirectNote('pending_review_sig')}
                >
                  You have <Link>{todoCount?.revierAndCoSignCount} notes</Link>{' '}
                  pending for review & Co-sign
                </li>
                {/* <li
                  className="appt-smry-inr-lbl alt-rw"
                  onClick={() => handleRedirectNote('treat_update')}
                >
                  You have{' '}
                  <Link to="">{todoCount?.planUpdate} treatment plan</Link> for
                  update
                </li> */}
                <li
                  className="appt-smry-inr-lbl"
                  onClick={() => handleRedirectNote('treat_review')}
                >
                  You have{' '}
                  <Link to="">{todoCount?.planReview} treatment plan</Link> due
                  for review
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppToDo;
